import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { reportingEffects } from 'src/app/root-store/reporting-store/effects';
import { reportingReducer } from './reducers';
import { reportingFeatureKey } from './reporting.state';
import { EnvironmentProviders } from '@angular/core';

export const provideReportingStore = (): EnvironmentProviders[] => [
    provideState(reportingFeatureKey, reportingReducer),
    provideEffects(reportingEffects)
];
